import React from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'

export default ({ sliderSettings, trips }) => (
  <div className="trip__slider">
    <div className="container">
      <Slider {...sliderSettings} className="carousel">
        {trips.map(trip => (
          <Link key={trip.id} to={{
            pathname: `/${trip.slug}`,
            state: {
              to: 'trip'
            }
          }}>
            <div className="carousel__slide">
              <h2 className="carousel__title">{trip.title.rendered}</h2>
              <div className="carousel__holder">
                <img
                  className="carousel__image"
                  src={trip.acf.img_trip.url}
                  alt={trip.acf.img_trip.alt}
                />
              </div>
            </div>
          </Link>
        ))}
      </Slider>
    </div>
  </div>
)


// WEBPACK FOOTER //
// ./src/components/Step/StepTripSlider/StepTripSlider.js